import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ContractPaymentDetailApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'contract-payment-detail'
  }


}
